import { all, call, takeLatest, select, put } from 'redux-saga/effects';

import {
  apiFetchTutorList,
  apiFetchTutorListFilterOptions,
} from '@dragonfruit/services/apis';
import { getRegion } from '@dragonfruit/redux/locale';
import { getTutorList } from '@dragonfruit/redux/tutorList';
import {
  FETCH_TUTORS,
  fetchTutorListSuccess,
  fetchTutorListFailure,
  FETCH_TUTORS_FILTER_OPTIONS,
  fetchTutorListFilterOptionsSuccess,
  fetchTutorListFilterOptionsFailure,
} from '@dragonfruit/redux/tutorList';

export function* fetchTutorListFlow(action) {
  try {
    const tutorList = yield select(getTutorList);
    const region = yield select(getRegion);
    const { filterName, page } = action.payload;

    const {
      filterType,
      currentPage,
      totalPages,
      tutors,
    } = yield call(apiFetchTutorList, { region, filterName, page });

    const isFirstPage = currentPage === 1;

    yield put(
      fetchTutorListSuccess({
        filterType,
        currentPage,
        totalPages,
        tutors: isFirstPage ? tutors : [...tutorList.tutors, ...tutors],
      })
    );
  } catch (error) {
    yield put(fetchTutorListFailure(error));
  }
}

export function* fetchTutorListFilterOptionsFlow() {
  try {
    const region = yield select(getRegion);
    const { school, subjectCategory } = yield call(
      apiFetchTutorListFilterOptions,
      {
        region,
      }
    );
    yield put(fetchTutorListFilterOptionsSuccess({ school, subjectCategory }));
  } catch (error) {
    yield put(fetchTutorListFilterOptionsFailure(error));
  }
}

export default function*() {
  yield all([
    takeLatest(FETCH_TUTORS, fetchTutorListFlow),
    takeLatest(FETCH_TUTORS_FILTER_OPTIONS, fetchTutorListFilterOptionsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tutorList.js